<!--
  @component
  Generates an SVG stacked bar chart.
 -->
<script>
  import { getContext } from "svelte";

  import { getHoverIndex } from "./chartUtils";

  export let hideHoverState = false;
  export let selectIndex;

  // shows a 4px high gray bar if the data value is 0 for a given column
  export let showEmptyBars = false;

  export let hoveringX;
  let hoveredBarIndex;

  const { data, xGet, yGet, zGet, height } = getContext("LayerCake");

  let padding = 2;

  $: calculateWidth = (d, i, series) => {
    if (i === series.length - 1) {
      return $xGet(series[i]) - $xGet(series[i - 1]) - padding;
    } else {
      return $xGet(series[i + 1]) - $xGet(d) - padding;
    }
  };

  $: hoveredBarIndex = getHoverIndex(
    $data[0],
    hoveringX,
    (d) => d.data.date,
    "down",
  );
</script>

<g class="column-group">
  {#each $data as series, i}
    {#each series as d, j}
      {@const yVals = $yGet(d)}
      {@const actualHeight = yVals[0] - yVals[1]}
      {@const showEmptyBar = showEmptyBars && actualHeight === 0 && i === 0}
      {@const minHeight = yVals[0] - yVals[1] > 0 ? 2 : 0}
      {@const columnHeight = Math.max(yVals[0] - yVals[1], minHeight)}
      {@const usedMinHeight = yVals[0] - yVals[1] < minHeight}
      {@const width = calculateWidth(d, j, series)}

      {#if width > 0}
        <rect
          class="group-rect {selectIndex !== undefined && selectIndex != i
            ? 'opacity-50'
            : 'opacity-100'}"
          data-id={i}
          x={$xGet(d)}
          y={showEmptyBar
            ? $height - 2
            : usedMinHeight
              ? yVals[1] - Math.abs(yVals[0] - yVals[1] - minHeight)
              : yVals[1]}
          {width}
          height={columnHeight || (showEmptyBar ? 2 : 0)}
          fill={minHeight === 0 ? "rgba(255, 255, 255, 0.1)" : $zGet(series)}
        ></rect>
      {/if}

      {#if width > 0 && !hideHoverState}
        <rect
          class="group-rect"
          data-id={i}
          x={$xGet(d)}
          y={0}
          {width}
          height={$height}
          fill={hoveredBarIndex === j
            ? "rgba(255, 255, 255, 0.1)"
            : "rgba(255, 255, 255, 0)"}
        />
      {/if}
    {/each}
  {/each}
</g>
